module.exports = __webpack_public_path__ + "static/404OK-6c3061180711e6f45a1896ad08a08b5d.jpg";